import React, { useState, useEffect } from "react";
import history from "../../history";
import {
  Row,
  Col,
  Form,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Icon from "react-icons-kit";
import { ic_mode_edit } from "react-icons-kit/md/ic_mode_edit";

import "react-toastify/dist/ReactToastify.css";
import InputText from "../InputText";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import EditVinAndAddVehicle from "../EditVinAndAddVehicle";

import { fetchQueryParams } from "../../utils/comman";

import { helperFunctionForBooleanValue } from "../../utils/helperFunction";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };

const initialState = {
  formId: "",
  status: "",
  rejectionReason: "",
  toggleRejectModal: false,
  vin: "",
  toggleEditVin: false,
  editId: "",
};
export default function riderMembershipDetail(props) {
  let { elements, rowData, singleRidesMembership, consentForm } = props;

  console.log({ rowData, singleRidesMembership, consentForm });

  const [state, setState] = useState(initialState);

  useEffect(() => {
    const params = fetchQueryParams(props.query);
    props.handleFetchSingleRideMembership(params.guid);
    state.formId = params.guid;
    setState({ ...state });
  }, []);

  useEffect(() => {
    const params = fetchQueryParams(props.query);
    props.handleFetchUserVehicles(params.vehicleId);
  }, []);

  const handleEditVin = (e, id) => {
    state.toggleEditVin = !state.toggleEditVin;
    state.editId = id;
    setState({ ...state });
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const handleNameChange = (e, id) => {
    let value = e.target.value;
    state[e.target.name] = value;
    setState({ ...state });
  };

  const handleToggleRejectModal = () => {
    state.toggleRejectModal = false;
    setState({ ...state });
  };

  const handleToSelectVehicle = () => {
    const params = fetchQueryParams(props.query);
    history.push(
      `/user/vechile-onboarding?guid=${params.guid}&id=${params.id}`
    );
    window.sessionStorage.setItem("prevFlag", "detail");
  };

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    if (status === "REJECTED") {
      state.status = "REJECTED";
      state.toggleRejectModal = true;
      setState({ ...state });
    } else if (status === "APPROVED") {
      state.status = "APPROVED";
      setState({ ...state });
      let data = {
        formId: state.formId,
        status: state.status,
        rejectionReason: "",
      };
      props.handleApproveRideMembership(data);
      // console.log({ data });
    }
  };

  const handleSubmitRejection = (e) => {
    e.preventDefault();

    let data = {
      formId: state.formId,
      status: state.status,
      rejectionReason: state.rejectionReason,
    };
    state.toggleRejectModal = false;
    setState({ ...state });
    props.handleApproveRideMembership(data);
  };

  const handleSelectExistingVehicle = (data) => {
    const params = fetchQueryParams(props.query);
    state.toggleEditVin = false;
    setState({ ...state });
    props.handlePendingVehicleOnboarding(data, params.vehicleId);
  };

  const handleVehicleOnBoarding = (data) => {
    props.handleVehicleOnBoardingFromMemberShip(data);
  };

  const handleUpdateVin = (data) => {
    state.toggleEditVin = false;
    setState({ ...state });
    props.handleUpdateVin(data);
  };

  return (
    <React.Fragment>
      {props.consentFormStatus !== false ? <Loader /> : null}
      {props.singleRidesMembershipStatus !== false ? <Loader /> : null}
      {props.approvingRidesMembershipStatus !== false ? <Loader /> : null}
      <div className="hideSearch">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "memberShipDetailElements.headingElement",
                  "Riders Application"
                )}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            {props.singleRidesMembership ? (
              <CardBody>
                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                      <span>
                        {_.get(
                          elements,
                          "memberShipDetailElements.subHeadingUserElement",
                          "User Details"
                        )}
                      </span>
                    </h2>
                  </Col>
                </Row>

                <Row>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.fNameLabel",
                        "First Name"
                      )}
                      titleName={props.singleRidesMembership.firstName}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.lNameLabel",
                        "Last Name"
                      )}
                      titleName={props.singleRidesMembership.lastName}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.callingCodeLabel",
                        "Calling Code"
                      )}
                      titleName={props.singleRidesMembership.callingCode}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.mobileLabel",
                        "Mobile Number"
                      )}
                      titleName={props.singleRidesMembership.mobile}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.emailLabel",
                        "Email Id"
                      )}
                      titleName={props.singleRidesMembership.email}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.moderationLabel",
                        "Moderation Status"
                      )}
                      titleName={props.singleRidesMembership.moderationStatus}
                    />
                  </Col>
                  <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                    <DesignCard
                      name={_.get(
                        elements,
                        "memberShipDetailElements.hasRecievedGiftsLabel",
                        "Gift Recieved?"
                      )}
                      titleName={helperFunctionForBooleanValue(
                        props.singleRidesMembership.hasRecievedGifts
                      )}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                      <span>
                        {_.get(
                          elements,
                          "memberShipDetailElements.subHeadingGdprConsentsElement",
                          "GDPR Consents"
                        )}
                      </span>
                    </h2>
                  </Col>
                </Row>

                {props.consentForm ? (
                  <Row>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.phoneLabel",
                          "Phone"
                        )}
                        titleName={
                          props.consentForm.donotphone !== true ? "Yes" : "No"
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.emailConsentsLabel",
                          "Email"
                        )}
                        titleName={
                          props.consentForm.donotemail !== true ? "Yes" : "No"
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.allPromotionsLabel",
                          "All Promotions"
                        )}
                        titleName={
                          props.consentForm.allpromotions !== true
                            ? "No"
                            : "Yes"
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.communityActivitiesLabel",
                          "Community Activities"
                        )}
                        titleName={
                          props.consentForm.communityactivities !== true
                            ? "No"
                            : "Yes"
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.promotionsLabel",
                          "Promotion & News"
                        )}
                        titleName={
                          props.consentForm.promotionsnews !== true
                            ? "No"
                            : "Yes"
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.surveyLabel",
                          "Survey and Search"
                        )}
                        titleName={
                          props.consentForm.surveysandresearch !== true
                            ? "No"
                            : "Yes"
                        }
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="mb-4 mx-auto">
                      <span className="error-text">
                        {_.get(
                          elements,
                          "memberShipDetailElements.gdprNotFoundText",
                          `Note :Consents are required to complete the registration`
                        )}
                      </span>
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                      <span>
                        {_.get(
                          elements,
                          "memberShipDetailElements.subHeadingVehicleElement",
                          "Vehicle Details"
                        )}
                      </span>
                    </h2>
                  </Col>
                </Row>
                {props.singleRidesMembership.motorcycle ? (
                  <Row>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.modelNameLabel",
                          "Model Name"
                        )}
                        titleName={
                          props.singleRidesMembership.motorcycle
                            .vehicleModelName
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.modelCodeLabel",
                          "Model Code"
                        )}
                        titleName={
                          props.singleRidesMembership.motorcycle
                            .vehicleModelCode
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.modelColorLabel",
                          "Model Color"
                        )}
                        titleName={
                          props.singleRidesMembership.motorcycle
                            .vehicleModelColor
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.registrationNumberLabel",
                          "Registration Number"
                        )}
                        titleName={
                          props.singleRidesMembership.motorcycle.registrationNo
                        }
                      />
                    </Col>

                    {props.singleRidesMembership.motorcycle &&
                    props.singleRidesMembership.motorcycle.vin !== "" ? (
                      <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                        {/* {state.toggleEditVin !== false ? (
                          <React.Fragment>
                            <div className="design-card position-relative">
                              <InputText
                                labelName={_.get(
                                  elements,
                                  "memberShipDetailElements.vinLabel",
                                  "VIN"
                                )}
                                inputType={"tel"}
                                customValue={state.vin}
                                inputName={"vin"}
                                InputClass={"my-2 inputText position-relative"}
                                inputPlaceholder={_.get(
                                  elements,
                                  "memberShipDetailElements.vinPlaceholder",
                                  "Enter VIN"
                                )}
                                customOnChange={(e) =>
                                  handleNameChange(e, "vin")
                                }
                                customRequired={true}
                                customMaxLength={17}
                              />

                              <Icon
                                className="editIcon"
                                onClick={(e) => handleEditVin(e)}
                                icon={ic_mode_edit}
                              />
                            </div>
                          </React.Fragment>
                        ) : ( */}
                        <React.Fragment>
                          <div className="design-card position-relative">
                            <DesignCard
                              name={_.get(
                                elements,
                                "memberShipDetailElements.vinLabel",
                                "VIN"
                              )}
                              titleName={
                                props.singleRidesMembership.motorcycle.vin
                              }
                            />
                            <Icon
                              className="editIcon"
                              onClick={(e) => handleEditVin(e, "update")}
                              icon={ic_mode_edit}
                            />
                          </div>
                        </React.Fragment>
                        {/* )} */}
                      </Col>
                    ) : (
                      <Col xl={3} lg={4} md={6} sm={6} className="mb-2">
                        <div className="design-card position-relative">
                          <DesignCard
                            name={_.get(
                              elements,
                              "memberShipDetailElements.vinLabel",
                              "VIN"
                            )}
                            titleName={
                              props.singleRidesMembership.motorcycle.vin
                            }
                          />
                          <Icon
                            className="editIcon"
                            onClick={(e) => handleEditVin(e, "update")}
                            icon={ic_mode_edit}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                ) : (
                  <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="mb-4 mx-auto">
                      <CustomButton
                        customType={"button"}
                        name={_.get(
                          elements,
                          "eventDetailElement.selectVehicleButtonElement",
                          "Add Vehicle"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={(e) => handleEditVin(e, "add")}
                      />
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col md="12">
                    <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                      <span>
                        {_.get(
                          elements,
                          "memberShipDetailElements.subHeadingBranchElement",
                          "Branch Details"
                        )}
                      </span>
                    </h2>
                  </Col>
                </Row>

                {props.singleRidesMembership.branch ? (
                  <Row>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.branchPrincipalNameLabel",
                          "Branch Principal Name"
                        )}
                        titleName={
                          props.singleRidesMembership.branch.branchPrincipalName
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.branchCodeLabel",
                          "Branch Code"
                        )}
                        titleName={
                          props.singleRidesMembership.branch.branchCode
                        }
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.branchIdLabel",
                          "Branch Id"
                        )}
                        titleName={props.singleRidesMembership.branch.branchId}
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.countryLabel",
                          "Country"
                        )}
                        titleName={props.singleRidesMembership.branch.country}
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.stateLabel",
                          "State"
                        )}
                        titleName={props.singleRidesMembership.branch.state}
                      />
                    </Col>
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "memberShipDetailElements.cityLabel",
                          "City"
                        )}
                        titleName={props.singleRidesMembership.branch.city}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="mb-4 mx-auto">
                      <span className="error-text">
                        {_.get(
                          elements,
                          "memberShipDetailElements.branchNotFoundText",
                          `Note : Branch selection is required to complete the
                          registration`
                        )}
                      </span>
                    </Col>
                  </Row>
                )}

                <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "memberShipDetailElements.backButtonElement",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                    customClick={(e) => handleGoBack(e)}
                  />
                  {props.singleRidesMembership.branch && props.consentForm ? (
                    props.singleRidesMembership.motorcycle &&
                    props.singleRidesMembership.motorcycle.vin !== "" ? (
                      props.singleRidesMembership.moderationStatus ===
                      "PENDING" ? (
                        <React.Fragment>
                          <CustomButton
                            customType={"button"}
                            name={_.get(
                              elements,
                              "memberShipDetailElements.rejectButtonElement",
                              "Reject"
                            )}
                            customClass={
                              "btn-outline-dark bg-none ml-2 btnthemeColor"
                            }
                            customClick={(e) =>
                              handleStatusSubmit(e, "REJECTED")
                            }
                          />
                          <CustomButton
                            customType={"submit"}
                            name={_.get(
                              elements,
                              "memberShipDetailElements.approveButtonElement",
                              "Approve"
                            )}
                            customClass={
                              "btn-outline-dark bg-none ml-2 btnthemeColor"
                            }
                            customClick={(e) =>
                              handleStatusSubmit(e, "APPROVED")
                            }
                          />
                        </React.Fragment>
                      ) : props.singleRidesMembership.moderationStatus ===
                        "APPROVED" ? null : (
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "memberShipDetailElements.approveButtonElement",
                            "Approve"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => handleStatusSubmit(e, "APPROVED")}
                        />
                      )
                    ) : null
                  ) : props.singleRidesMembership.motorcycle &&
                    props.singleRidesMembership.motorcycle.vin ===
                      "" ? null : null}
                </div>
              </CardBody>
            ) : null}
          </Card>
        </Form>
        <Modal isOpen={state.toggleRejectModal}>
          <ModalHeader toggle={handleToggleRejectModal}>
            {_.get(
              elements,
              "memberShipDetailElements.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={state.rejectionReason}
              customOnChange={(e) => handleNameChange(e, "all")}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "memberShipDetailElements.rejectModelButtonElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => handleSubmitRejection(e)}
            />
          </ModalFooter>
        </Modal>
        <Modal size={"xl"} isOpen={state.toggleEditVin} centered>
          <ModalHeader toggle={(e) => handleEditVin(e, "update")}>
            {_.get(
              elements,
              "memberShipDetailElements.rejectionModelLabels",
              "Update VIN"
            )}
          </ModalHeader>
          <ModalBody>
            <EditVinAndAddVehicle
              query={props.query}
              motorCycleStatus={props.motorCycleStatus}
              motorCycle={props.motorCycle}
              motorCycleCountryStatus={props.motorCycleCountryStatus}
              motorCycleCountry={props.motorCycleCountry}
              handleFetchMotorCycle={props.handleFetchMotorCycle}
              handleVechicleOnboarding={props.handleVechicleOnboarding}
              handlePendingVehicleOnboarding={handleSelectExistingVehicle}
              vechicleOnboardingStatus={props.vechicleOnboardingStatus}
              elements={props.elements}
              userVehicles={props.userVehicles}
              userVehiclesStatus={props.userVehiclesStatus}
              motorCycleDetails={
                props.singleRidesMembership &&
                props.singleRidesMembership.motorcycle
              }
              editId={state.editId}
              handleUpdateVin={handleUpdateVin}
              handleVehicleOnBoarding={handleVehicleOnBoarding}
              rowData={props.rowData}
            />
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
}
